import React, { useEffect, useState } from 'react';
import './InstallPrompt.css';

const InstallPrompt = ({ onInstallClick, onClose }) => {
  const [isIOS, setIsIOS] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);
  const [hasAttemptedInstall, setHasAttemptedInstall] = useState(false);

  useEffect(() => {
    // Detectar si el usuario está en un dispositivo iOS
    const userAgent = window.navigator.userAgent.toLowerCase();
    setIsIOS(/iphone|ipad|ipod/.test(userAgent));

    // Verificar si la app ya está instalada en iOS (Standalone mode)
    if (window.navigator.standalone) {
      setIsInstalled(true);
    }

    // Verificar si la app está en modo standalone en Android y navegadores de escritorio que soportan PWA
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsInstalled(true);
    }

    // Verificar si la app se ha instalado (para Android y navegadores que soportan PWA)
    const handleAppInstalled = () => {
      setIsInstalled(true);
      localStorage.setItem('hasAttemptedInstall', 'true');
    };
    window.addEventListener('appinstalled', handleAppInstalled);

    // Revisar si el usuario ya intentó instalar la app
    const installAttempted = localStorage.getItem('hasAttemptedInstall') === 'true';
    setHasAttemptedInstall(installAttempted);

    // Limpiar el event listener al desmontar el componente
    return () => {
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  const handleInstallClick = () => {
    onInstallClick();
    localStorage.setItem('hasAttemptedInstall', 'true');
    setIsInstalled(true); // Cerramos el mensaje y asumimos que se está instalando
  };

  // No mostrar el prompt si la app ya está instalada, en modo standalone, o si ya se intentó instalar
  if (isInstalled || hasAttemptedInstall) {
    return null;
  }

  return (
    <div className="install-prompt">
      <div className="install-content">
        <button className="close-button" onClick={onClose}>X</button>
        <h2>Instala nuestra App</h2>
        {isIOS ? (
          <>
            <p>Para mejorar tu experiencia de navegación, instala nuestra app.</p>
            <p>
              Presiona el botón de compartir 
              <img 
                src="/images/share.png" 
                alt="Icono de compartir" 
                className="share-icon" 
              /> en la parte inferior de la pantalla y selecciona 
              <span style={{ fontWeight: 'bold' }}> "Agregar a pantalla de inicio"</span>.
            </p>
          </>
        ) : (
          <>
            <p>Para mejorar tu experiencia de navegación, instala nuestra app.</p>
            <button className="install-button" onClick={handleInstallClick}>Instalar ahora</button>
          </>
        )}
      </div>
    </div>
  );
};

export default InstallPrompt;
